import type { SVGProps } from 'react';

export function ShPinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden='true' viewBox='0 0 40 56' {...props}>
      <path
        d='M3.37 31.11A20 20 0 1 1 36.63 31.11L20 56Z'
        fill='currentColor'
      />
      <path
        transform='translate(7.4 10.1) scale(0.6)'
        fill='var(--color-sh-paper)'
        d='M10.665 24.036c-4.093 0-7.764-1.334-10.549-3.792l3.207-3.792c2.236 1.834 4.726 2.875 7.553 2.875s3.248-.875 3.248-2.083c0-1.208-1.054-1.667-4.388-2.458-4.894-1.084-8.565-2.417-8.565-6.959 0-4.541 3.502-7.25 8.734-7.25s6.836 1.084 9.283 3.084l-2.912 4.041c-2.11-1.583-4.388-2.416-6.54-2.416s-2.869.875-2.869 1.958 1.097 1.833 4.515 2.583c5.147 1.084 8.439 2.542 8.439 6.792s-3.502 7.375-9.199 7.375l.043.042ZM38.63.994h2.617v22.667H38.63V13.327H25.129v10.334h-2.616V.994h2.616v9.875H38.63V.994Z'
      />
    </svg>
  );
}
